module.exports = __webpack_public_path__ + "static/media/AB_O1_6.c30d539f.jpg";